import { useState, useEffect } from 'react'
import { supabase } from '../../utils/supabaseClient'
import { useNavigate } from 'react-router-dom'
import styles from './UpdatePassword.module.scss'

export default function RecoveryUpdatePassword() {
  const [loading, setLoading] = useState(false)
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState(null)
  const [message, setMessage] = useState(null)
  const navigate = useNavigate()

  useEffect(() => {
    const processRecovery = async () => {
      const hashParams = new URLSearchParams(window.location.hash.substring(1));
      const type = hashParams.get('type');
      const accessToken = hashParams.get('access_token');
      const refreshToken = hashParams.get('refresh_token');

      if (type === 'recovery' && accessToken) {
        try {
          const { data, error } = await supabase.auth.setSession({
            access_token: accessToken,
            refresh_token: refreshToken
          });

          if (error) throw error;

          if (data?.session) {
            window.history.replaceState(null, '', '/recovery-update-password');
          } else {
            throw new Error('No session established');
          }
        } catch (err) {
          console.error('Error during recovery process:', err);
          setError('Error processing recovery link. Please try again.');
          navigate('/login', { replace: true });
        }
      } else {
        navigate('/login', { replace: true });
      }
    };

    processRecovery();
  }, [navigate]);

  const handlePasswordUpdate = async (event) => {
    event.preventDefault()
    setError(null)
    setMessage(null)

    if (password !== confirmPassword) {
      setError('Las contraseñas no coinciden')
      return
    }

    if (password.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres')
      return
    }

    setLoading(true)

    try {
      const { error } = await supabase.auth.updateUser({
        password: password
      })

      if (error) throw error

      setMessage('Contraseña actualizada exitosamente')
      setTimeout(() => {
        navigate('/', { replace: true })
      }, 2000)
    } catch (err) {
      console.error('Password update error:', err)
      setError(err.message || 'Error al actualizar la contraseña')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={styles.updatePasswordContainer}>
      <h2>Actualizar Contraseña</h2>
      <div className={styles.formContainer}>
        <article className={styles.description}>
          <p>Ingresa tu nueva contraseña</p>
        </article>
        {error && <div className={styles.error}>{error}</div>}
        {message && <div className={styles.success}>{message}</div>}
        <form onSubmit={handlePasswordUpdate}>
          <div>
            <input
              className={styles.inputField}
              type="password"
              placeholder="Nueva contraseña"
              value={password}
              required={true}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div>
            <input
              className={styles.inputField}
              type="password"
              placeholder="Confirmar contraseña"
              value={confirmPassword}
              required={true}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>
          <div>
            <button className={styles.button} disabled={loading}>
              {loading ? <span>Loading</span> : <span>Actualizar contraseña</span>}
            </button>
          </div>
        </form>
        <button 
          className={styles.switchButton} 
          onClick={() => navigate('/login')}
        >
          Volver al login
        </button>
      </div>
    </div>
  )
} 